'use strict';

var find = new Swiper(".concept__family__marquee", {
  loop: true,
  slidesPerView: "auto",
  speed: 50000,
  allowTouchMove: false,
  simulateTouch: false,
  autoplay: {
    delay: 0,
    disableOnInteraction: false
  }
});